<template>
  <FreeModal :name="name" :persistent="isPersistent">
    <template #header>
      <h3 class="text-text-neutral-primary text-center text-lg font-semibold">
        {{ title }}
      </h3>
    </template>
    <template #default="{ hide, params }">
      <div class="mt-1 space-y-6">
        <p class="text-text-neutral-secondary text-center text-sm font-medium">
          {{ message }}
        </p>
        <div class="space-y-2">
          <slot name="action" :hide="hide" :params="params"></slot>
        </div>
      </div>
    </template>
  </FreeModal>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { FreeModal } from 'freedom-shared';
  import { controllerModel } from 'shared';

  const props = defineProps<{
    name: string;
  }>();

  const { t } = useI18n();

  const modal = controllerModel.useModal();
  const modalParams = computed(() => modal.getParams(props.name));
  const title = computed(
    () => modalParams.value?.title || t('booking.errors.default.title'),
  );
  const message = computed(
    () => modalParams.value?.message || t('booking.errors.default.description'),
  );
  const isPersistent = computed(() => Boolean(modalParams.value?.persistent));
</script>
